import { render, staticRenderFns } from "./channelAccount.vue?vue&type=template&id=d6160170&"
import script from "./channelAccount.vue?vue&type=script&lang=js&"
export * from "./channelAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports